export const STORYTELLING_QUESTION_PRESET_KEYS = [
  "storyBehind",
  "whyCreated",
  "cuisineSpecial",
  "ingredientsSource",
  "signatureDish",
  "guestExperience",
  "menuInspiration",
  "values",
  "differentiators",
  "futureVision",
];

export const STORYTELLING_QUESTION_OTHER_KEY = "other";

export function getStorytellingPresetQuestionText(key, t) {
  if (!key || key === STORYTELLING_QUESTION_OTHER_KEY) return "";
  return t(`storytellingPresetQuestion_${key}`);
}

export function resolveStorytellingQuestionKey(question, t, i18n) {
  const trimmed = String(question || "").trim();
  if (!trimmed) return "";

  const matchesPreset = (key) => {
    if (getStorytellingPresetQuestionText(key, t) === trimmed) return true;
    if (!i18n?.languages?.length) return false;
    return i18n.languages.some(
      (lng) => i18n.t(`storytellingPresetQuestion_${key}`, { lng }) === trimmed
    );
  };

  const matched = STORYTELLING_QUESTION_PRESET_KEYS.find(matchesPreset);
  if (matched) return matched;

  return STORYTELLING_QUESTION_OTHER_KEY;
}

export function getStorytellingQuestionSelectOptions(t) {
  return [
    ...STORYTELLING_QUESTION_PRESET_KEYS.map((key) => ({
      value: key,
      label: getStorytellingPresetQuestionText(key, t),
    })),
    {
      value: STORYTELLING_QUESTION_OTHER_KEY,
      label: t("storytellingPresetQuestion_other"),
    },
  ];
}
